import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Card } from 'aem-libs-react-components/src/components/common/card'
import { TextField } from 'aem-libs-react-components/src/components/forms/text-field'
import { useDynamicParams } from 'aem-libs-react-ts/src/hooks/useDynamicParams'
import { gaTracker } from 'aem-libs-react-ts/src/utils/gaTracker'
import { pipe } from 'aem-libs-ts/src/utils/common/pipe'
import { clearSpaces } from 'aem-libs-ts/src/utils/string/clearSpaces'

import { allowedZipList, trackingName, zipPattern } from '../constants'
import { testIds } from '../e2e/testIds'
import type { AllowedStateType, MembershipParams } from '../types'
import { Cards, FieldsWrapper, SubmitButton } from './App.styled'


const zipLength = 5

const formatZip = (zipCode: string) => {
  const spaceIndex = 3
  const digits = zipCode.replaceAll(/\s+/g, '').slice(0, zipLength)
  return `${digits.slice(0, spaceIndex)} ${digits.slice(spaceIndex)}`
}

const isValidZip = (zip: string) =>
  pipe(() => zip)
    .map(clearSpaces)
    .map((z) => z.length === zipLength)
    .get()

const checkZip = (zip: number): AllowedStateType => (allowedZipList.includes(zip) ? 'allowed' : 'notAllowed')

interface ZipCheckProps {
  onAllowedState: (state: AllowedStateType) => void
}

export const ZipCheck = ({ onAllowedState }: ZipCheckProps) => {
  const [zip, setZip] = useState('')
  const { zipCodeCheckContent, agreement } = useDynamicParams<MembershipParams>()
  const { t } = useTranslation()

  const handleSubmitZip = () => {
    const viewType = pipe(() => zip)
      .map(clearSpaces)
      .map(Number)
      .map(checkZip)
      .tap((allowedState) =>
        gaTracker.onFormSubmit('membership-psc-jak-se-zapojit', trackingName.zipCodeForm, {
          ['zipCode']: {
            value: [zip],
            elementID: 'zipCode',
            elementName: trackingName.zipCode
          },
          ['allowedState']: {
            value: [allowedState],
            elementID: 'allowedState',
            elementName: trackingName.allowedState
          }
        })
      )
      .get()

    onAllowedState(viewType)
  }

  return (
    <Cards>
      <div />
      <Card textAlign={'left'}>
        <FieldsWrapper>
          <div data-testid={testIds.zipCheckContent} dangerouslySetInnerHTML={{ __html: zipCodeCheckContent }} />
          <TextField
            label={t('ZIP_CODE_LABEL')}
            pattern={zipPattern}
            value={zip}
            maxLength={zipLength}
            testId={testIds.zipInputBase}
            onFocus={(e) => setZip(clearSpaces(e.target.value))}
            onChange={(e) => {
              return setZip(e.target.value)
            }}
            onBlur={() => setZip(formatZip)}
          />
          <div data-testid={testIds.agreement} dangerouslySetInnerHTML={{ __html: agreement }} />
          <SubmitButton
            data-testid={testIds.checkButton}
            type={'button'}
            onClick={handleSubmitZip}
            disabled={!isValidZip(zip)}
          >
            {t('CHECK_REGION_BUTTON')}
          </SubmitButton>
        </FieldsWrapper>
      </Card>
      <div />
    </Cards>
  )
}
